import { useEffect } from 'react';
import { UtmQueryParamKey, UtmStorageKey } from '@gokrew/models/constants';

const UTM_COOKIE_MAX_AGE_DAYS = 30;

function persistToCookie(value: string) {
  const maxAgeSeconds = UTM_COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;
  document.cookie = `${UtmStorageKey.UTM_PARAMS}=${encodeURIComponent(
    value
  )}; path=/; max-age=${maxAgeSeconds}; SameSite=Lax`;
}

/**
 * Captures utm_* query params the marketing site attaches to portal links
 * and persists them to localStorage + a cookie so they survive navigation
 * away from the landing URL. Only writes when at least one utm param is
 * present, so internal navigation without utm params never clears prior
 * attribution.
 */
export function useUtmCapture() {
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const utmParams: Record<string, string> = {};
    Object.values(UtmQueryParamKey).forEach((key) => {
      const value = searchParams.get(key);
      if (value) utmParams[key] = value;
    });

    if (Object.keys(utmParams).length === 0) return;

    const serialized = JSON.stringify(utmParams);
    localStorage.setItem(UtmStorageKey.UTM_PARAMS, serialized);
    persistToCookie(serialized);
  }, []);
}
